<script setup lang="ts">
useHead({ title: 'Kontakty' })
</script>

<template>
  <div fubex-container>
    <div :data-test="getCypressId('body-header')" flex flex-col gap-24px items-center text-center mt="32px lg:86px" md:mt-116px mb-48px>
      <h1 heading1 text-neutral-900 font-700>
        Kontaktujte nás
      </h1>
      <h3 text-neutral-900 paragraph-md max-w-648px>
        Nevíte si rady, potřebujete poradit nebo nám chcete dát zpětnou vazbu? Naše podpora je tu pro vás, tak nás neváhejte kontaktovat a velice rádi vám pomůžeme.
      </h3>
    </div>

    <div text-center>
      <div :data-test="getCypressId('office-prague')">
        <h2 heading4>
          Sídlo firmy
        </h2>
        <p>Jaurisova 515/4<br>140 00 Praha 4 - Michle</p>
        <p my-16px>
          E-mail:<NuxtLink to="mailto:support@bitbeli.cz" basic-link>
            support@bitbeli.cz
          </NuxtLink>
        </p>
        <div my="42px" h-400px fubex-rounded-lg>
          <iframe
            :data-test="getCypressId('maps-prague')"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10245.741588428282!2d14.430598449057138!3d50.05940713722212!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b9386fc19e791%3A0x1abb324e6bd10176!2sJaurisova%20515%2F4%2C%20140%2000%20Praha%204-Michle!5e0!3m2!1scs!2scz!4v1740407979540!5m2!1scs!2scz"
            style="border:0;" allowfullscreen="true" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            w-full h-full fubex-rounded-lg
          />
        </div>
      </div>
    </div>
  </div>
</template>
